import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Helmet } from 'react-helmet'
import { injectIntl } from 'react-intl'
import { createStructuredSelector } from 'reselect'
import { selectRoles, selectedRolesData } from 'redux/roles/selectors'
import RolesAction from 'redux/roles/actions'
import { Typography } from 'antd'
import ViewRoles from './ViewRoles'

const { Text } = Typography

const mapStateToProps = () =>
  createStructuredSelector({
    roles: selectRoles,
    selectedRoles: selectedRolesData,
  })

const StaffList = ({ selectedRoles, intl: { formatMessage } }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({
      type: RolesAction.LOAD_ALL,
    })
  }, [dispatch])

  return (
    <div>
      <Helmet title={formatMessage({ id: 'title.helmet.Role' })} />
      <div className="card">
        <div className="card-body">
          <h5 className="mb-4">
            <strong>{formatMessage({ id: 'text.RoleList' })}</strong>
            &nbsp;&nbsp;
            <Text className="font-size-16 font-weight-bold" code>
              {formatMessage({ id: 'text.totalCount' }, { count: selectedRoles?.length || 0 })}
            </Text>
          </h5>
          <ViewRoles />
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(injectIntl(StaffList))
